export default "__VITE_ASSET__eXSFXYwq__"